import exportApi from '../_api'
import transactionApi from '../../transactions/_api'
import i18n from '@/locales/'
export default {
  setExportsHistoryFilters: async (
    { commit },
    filters) => {
    commit('setExportsHistoryFilters', filters)
  },
  fetchExportationFlow: async (
    { commit, getters, dispatch },
    id
  ) => {
    try {
      let response = {}

      response = await exportApi.getExportationFlow(id)

      commit('setExportationFlow', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'export_fetch_exportation_flows_error'
        },
        { root: true }
      )
    }
  },
  fetchExportationFlows: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    try {
      const page = getters.exportationFlowsCurrentPage
      const filters = getters.exportationFlowsFilters
      let response = {}

      response = await exportApi.getExportationFlows(filters, false, page)

      commit('setExportationFlows', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'export_fetch_exportation_flow_error'
        },
        { root: true }
      )
    }
  },
  updateExportationFlow: async (
    { commit, dispatch, getters },
    exportationFlow
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportApi.putExportationFlow(
        exportationFlow.id,
        exportationFlow
      )
      commit('addExportationFlow', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_update_exportation_flow_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_update_exportation_flow_error' },
        { root: true }
      )
    } finally {
    }
  },
  createExportationFlow: async (
    { commit, dispatch, getters },
    exportationFlow
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportApi.postExportationFlow(exportationFlow)
      commit('addExportationFlow', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_create_exportation_flow_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_create_exportation_flow_error' },
        { root: true }
      )
    } finally {
    }
  },
  deleteExportationFlow: async (
    { commit, dispatch, getters },
    exportationFlowId
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      await exportApi.deleteExportationFlow(exportationFlowId)
      commit('deleteExportationFlow', exportationFlowId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_delete_exportation_flow_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_delete_exportation_flow_error' },
        { root: true }
      )
    } finally {
    }
  },
  createExportHistory: async (
    { commit, dispatch, getters },
    exportHistory
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportApi.postExportHistory(exportHistory)
      commit('setExportHistory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_create_export_history_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_create_export_history_error' },
        { root: true }
      )
    } finally {
    }
  },
  fetchExportsHistory: async (
    { commit, dispatch, getters }, { pagination = true }
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const page = getters.exportsHistoryCurrentPage
      const filters = getters.exportsHistoryFilters
      let response = {}
      if (pagination) {
        response = await transactionApi.getExportSettingsHistory(filters, true, page)
      } else {
        response = await transactionApi.getExportSettingsHistory(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setExportsHistoryLastPage', lastPage)
      commit('setExportsHistory', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_fetch_export_history_error' },
        { root: true }
      )
    } finally {
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }

}
